export default __webpack_public_path__ + "static/Etiqa-EGIB-b92b4decbfbe126c86340f6c9d889177.png";